import React from "react";
import "./style.scss";
import UserReportsList from "../../components/Reports/UserReportsList";

function UserReports() {
  return (
    <div className="coupons_wrapper">
      <div className="coupons">
        <UserReportsList />
      </div>
    </div>
  );
}

export default UserReports;
